(() => {
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
  let closeTimer;
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('.infinity-header header-menu');
    if (!menu) return;
    clearTimeout(closeTimer);
    document.querySelectorAll('.infinity-header header-menu details[open]').forEach(details => {
      if (!menu.contains(details)) details.removeAttribute('open');
    });
    const details = menu.querySelector('details');
    if (details) details.open = true;
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('.infinity-header header-menu');
    if (!menu || menu.contains(event.relatedTarget)) return;
    closeTimer = setTimeout(() => {
      if (!menu.contains(document.activeElement)) menu.querySelector('details')?.removeAttribute('open');
    }, 150);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('.infinity-header header-menu details[open]');
    if (!details) return;
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });
})();
